import moment from 'moment';

/*
 * How dates are shown to a person in the admin: 12-Sep-2026 9:32 PM.
 *
 * Display only. Anything sent to the API, parsed from it, used as a key or
 * written to an export keeps its own machine format (YYYY-MM-DD and friends).
 *
 * Parsing is plain `moment(value)`, exactly as the views did before, so times
 * stay in the browser's local zone. Month names are pinned to English.
 */

export const EMPTY_DATE = '—';

const DATE = 'DD-MMM-YYYY';
const DATE_TIME = 'DD-MMM-YYYY h:mm A';
const DATE_TIME_SECONDS = 'DD-MMM-YYYY h:mm:ss A';
const TIME = 'h:mm A';

function format(value, pattern, fallback) {
  if (value == null || value === '') return fallback;
  const m = moment.isMoment(value) ? value.clone() : moment(value);
  return m.isValid() ? m.locale('en').format(pattern) : fallback;
}

/** 12-Sep-2026 */
export function formatDisplayDate(value, fallback = EMPTY_DATE) {
  return format(value, DATE, fallback);
}

/** 12-Sep-2026 9:32 PM */
export function formatDisplayDateTime(value, fallback = EMPTY_DATE) {
  return format(value, DATE_TIME, fallback);
}

/** 12-Sep-2026 9:32:05 PM, for logs where the second matters. */
export function formatDisplayDateTimeSeconds(value, fallback = EMPTY_DATE) {
  return format(value, DATE_TIME_SECONDS, fallback);
}

/** 9:32 PM */
export function formatDisplayTime(value, fallback = EMPTY_DATE) {
  return format(value, TIME, fallback);
}
